"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimatingDashboardData = void 0;
const models_1 = require("../../../products/models");
const responses_1 = require("../../../sales-order/responses");
const models_2 = require("./../../models");
class EstimatingDashboardData {
}
exports.EstimatingDashboardData = EstimatingDashboardData;
//# sourceMappingURL=estimating-dashboard-data.response.js.map